import { render } from "./SortVideos.vue?vue&type=template&id=e3bff62c&scoped=true"
import script from "./SortVideos.vue?vue&type=script&lang=js"
export * from "./SortVideos.vue?vue&type=script&lang=js"

import "./SortVideos.vue?vue&type=style&index=0&id=e3bff62c&scoped=true&lang=css"
import "./SortVideos.vue?vue&type=style&index=1&id=e3bff62c&lang=css"

import exportComponent from "/Users/apple/Desktop/projects/Active Projects/EIEV/Media Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3bff62c"]])

export default __exports__